/*
 * Copyright (c) Worldline 2023.
 */

import {Component, OnInit, ViewChild} from '@angular/core';
import {Steps} from "../../constant/steps";
import {AgreementsOptions} from "../../constant/agreements-options";
import {SignerDto} from "../../model/signerDto";
import {SignatureDto} from "../../model/signatureDto";
import {ActivatedRoute, Router} from "@angular/router";
import {interval, Subscription, take} from "rxjs";
import {CustomErrors} from "../../constant/custom-errors";
import {HttpService} from "../../http/http.service";
import {NgxSpinnerService} from "ngx-spinner";
import {SbxEvents} from "../../constant/sbx-events";
import {Errors} from "../../constant/errors";
import {ConsentGroupDto} from "../../model/consentGroupDto";
import {DomSanitizer} from "@angular/platform-browser";
import {FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {CertificateService} from "../../services/certificate.service";
import {TranslateService} from "@ngx-translate/core";
import {Routes} from "../../constant/routes";
import {PadJWSDto} from "../../model/padJWSDto";
import {NgSignaturePadOptions, WlHandSignComponent} from "../wl-hand-sign/wl-hand-sign.component";
import {HandSignDto} from "../../model/handSignDto";
import {OtpSendDto} from "../../model/otpSendDto";
import {SharedService} from "../../services/shared.service";
import {CancelService} from "../../services/cancel.service";
import {RedirectionService} from "../../services/redirection.service";
import {SignerService} from "../../services/signer.service";

import {SessionService} from "../../services/session.service";
import {RootScopeService} from "../../services/rootscope.service";
import {Idle} from "@ng-idle/core";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import ExternalSignerStatusEnum = SignerDto.ExternalSignerStatusEnum;
import ExternalSignatureStatusEnum = SignatureDto.ExternalSignatureStatusEnum;
import ActionEnum = SignatureDto.ActionEnum;
import AgreementMethodEnum = SignatureDto.AgreementMethodEnum;
import ChannelsEnum = SignatureDto.ChannelsEnum;

@Component({
    selector: 'app-agreements',
    templateUrl: './agreements.component.html'
})
export class AgreementsComponent implements OnInit {


    otpPattern = AgreementsOptions.otpPattern;
    otpSent: boolean = false;
    submitted: boolean = false;
    submitting: boolean = false;
    currentSignaturePosition: number | undefined;
    currentSigner: SignerDto;
    smartphone: boolean = false;
    linkSMSAlreadySent: boolean = false;
    linkEmailAlreadySent: boolean = false;
    displayTabletLink: boolean = false;
    //Initialise signature button text
    signatureButtonText: string = 'documents.button';
    handsignEmpty: boolean = true;
    form: any = {};
    formConsentsValidation: FormGroup;
    formAgreementsValidation: FormGroup;
    signatureOnErrorText: string = '';
    signatureOnError: boolean = false;
    containsTrueSignatures: boolean = false;
    containsApprovals: boolean = false;
    containsMandatoryConsents: boolean = false;
    certificateValidation: any = {
        gcs: false,
        certificate: false
    };


    retry: Subscription | undefined;
    isCertificateApprovalRequired: boolean = false;
    areMultipleDocuments: boolean = false;
    // If controlDocumentCompleteReading is true then the document
    // need to be fully read to sign it.
    controlDocumentCompleteReading: boolean = false;
    // True if the user has read the whole document at least one time
    documentFullyRead = false;

    sessionId: string = '';

    //init hand signature dimensions here:
    handSignOptions: NgSignaturePadOptions = {canvasHeight: 150, canvasWidth: 500};

    mode: any;
    onHoldAvailability: boolean = false;
    onHoldLimitReached: boolean = false;

    signatures: SignatureDto[] = [];
    currentSignature: SignatureDto | any;
    trueSignatures: SignatureDto[] = [];
    approvals: SignatureDto[] = [];

    consents: any;
    alreadyConsented: boolean = false;
    sendSms: any;
    sendEmail: any;
    smartphoneAgreementSent: any;
    otp: any;
    otpErrorMsg: any;
    otpMsg: any;
    click: any;
    handsign: any;
    tablet: any;
    jnlpUrl: any;
    errorMsg: any;
    submit: any;
    smartphoneMsg: any;
    smartphoneErrorMsg: any;

    isLoaded: boolean = false;

    @ViewChild('signature')
    public signaturePad!: WlHandSignComponent;

    constructor(private route: ActivatedRoute,
                private redirectionService: RedirectionService,
                private rootScope: RootScopeService,
                private sessionService: SessionService,
                private signersService: SignerService,
                private translate: TranslateService,
                private router: Router,
                private shared: SharedService,
                public httpClient: HttpService,
                private spinner: NgxSpinnerService,
                private sanitizer: DomSanitizer,
                private formBuilder: FormBuilder,
                private certificateService: CertificateService,
                private cancelService: CancelService,
                private idle: Idle,
                private modalService: NgbModal) {
        this.currentSigner = this.signersService.currentSigner;
        this.formConsentsValidation = this.formBuilder.group({});
        this.formAgreementsValidation = this.formBuilder.group({
            codeOtp: ['']
        });

    }


    ngOnInit(): void {
        console.debug("Init Agreements");

        let that = this;

        // Load context
        this.rootScope.get().step = Steps.agreements;
        // this.currentSignature = signersService.currentSignature; TODO check if used ?
        // If controlDocumentCompleteReading is true then the document
        // need to be fully read to sign it.
        this.controlDocumentCompleteReading = this.rootScope.get().properties ? this.rootScope.get().properties.controlDocumentCompleteReading : false;
        // True if the user has read the whole document at least one time
        this.retry = interval(this.rootScope.get().properties.signature.retry).pipe(take(200)).subscribe(() => {
            if (this.smartphone) {
                console.info('Signer state is : ' + this.signersService.currentSigner.externalSignerStatus);
                this.getSignatures();
            } else {
                this.retry?.unsubscribe();
            }
        });

        //pdfReader type

        this.mode = this.sessionService.info.configDto.pdfReaderType;

        //on hold availability

        this.onHoldAvailability = this.signersService.currentSigner.signingMode !== 'FACE_TO_FACE' && this.sessionService.info.configDto.onHoldAvailability;

        this.onHoldLimitReached = this.onHoldAvailability && this.sessionService.info.onHoldCounter >= this.sessionService.info.configDto.onHoldMaxLimit;

        console.debug('The context is OK.');
        // Context Loaded

        // Initialize boolean to determine if the certificate data approval has been done or not on the signatures controller
        this.rootScope.get().isCertificateApprovalDone = false;

        // Check the sessionId
        this.sessionId = this.route.snapshot.params['sessionId'];

        //single redirectionFactory
        // this.redirectionService.get();

        if (this.sessionId !== this.sessionService.id) {
            console.warn('The session ID in the url is not the same as the saved : url->' + this.sessionId + ' | saved->' + this.sessionService.id);
            this.redirectionService.session(this.route, this.sessionId);
        }

        // Check the status of the session
        if (!this.sessionService.info || this.sessionService.info.externalSessionStatus !== ExternalSignatureStatusEnum.Init) {
            console.warn('The current signer is undefined or is not at the init status');
            this.redirectionService.session(this.route, this.sessionId);
        }

        // Check the status of the signer
        if (!this.signersService.currentSigner ||
            (this.signersService.currentSigner.externalSignerStatus !== ExternalSignerStatusEnum.Agreements &&
                this.signersService.currentSigner.externalSignerStatus !== ExternalSignerStatusEnum.PendingSignature)) {
            console.warn('The current signer is undefined or is not at the agreements status');
            this.redirectionService.session(this.route, this.sessionId);
        }


        this.shared.on(SbxEvents.DOCUMENT_FULLY_READ, function () {
                that.documentFullyRead = true;
            }
        );


// Enable spin
        this.spinner.show("spinner");

//refresh web page regularly, at most 10 times.
        this.shared.on('$destroy', function () {
                that.retry?.unsubscribe();
            }
        );
        // Start actions of the controller
        this.getSignatures().then(() => {
            that.isLoaded = true;
        });

    }


    signerName(): string {
        if (this.currentSigner) {
            return this.currentSigner.firstName + ' ' + this.currentSigner.lastName;
        } else {
            return '';
        }
    }

    exitError() {
        this.redirectionService.error(this.route, CustomErrors.unreachableService, this.sessionId);
    }

    signatureIsDone(signature: any) {
        return [ExternalSignatureStatusEnum.Agreed, ExternalSignatureStatusEnum.Successful].indexOf(signature.externalSignatureStatus) !== -1;

    }

    isFinalAgreement() {
        return this.currentSignature.action === ActionEnum.FinalAgreement;
    }

    formReset() {
        this.submitted = false;
    }


    isAlreadySent() {
        this.otpSent = true;
    }

    hold() {
        let that = this;

        console.debug('Hold the session');
        // Enable spin
        this.spinner.show('spinner');

        this.httpClient.hold(this.sessionId, this.signersService.currentSigner.extSignerId).toPromise()
            .then(function (response) {

                //Disable the spin
                that.spinner.hide('spinner');

                if (response?.success) {
                    console.debug('Hold the session : SUCCESS');
                    var urlOnHold = that.sessionService.info.urlOnHold;
                    if (urlOnHold) {
                        that.redirectionService.exit(that.sessionService.getUrlOnHold());
                    } else {
                        that.redirectionService.hold(that.route, that.sessionId);
                    }

                } else {
                    //Log the error and redirect
                    console.warn(response?.error);
                    that.errorMsg = 'error.unexpected';
                }
            }, that.exitError);
    }

    isSubmitButtonDisabled() {
        return (this.controlDocumentCompleteReading && !this.documentFullyRead) || !this.formConsentsValidation.valid || (this.isCertificateApprovalRequired && !(this.certificateValidation.gcs && this.certificateValidation.certificate));
    }

    confirmCancel() {
        this.cancelService.confirmCancel(this.route)
    }


    // Get all signatures from the API
    getSignatures() {
        let that = this;
        console.debug('Getting all the signatures');

        return this.httpClient.getAllSignatures(this.sessionId, this.signersService.currentSigner.extSignerId).toPromise().then(function (response) {

            if (response?.success) {
                // If no error

                if ((response.result as SignatureDto[]).length > 0) {
                    // Attach signatures into the scope
                    that.signatures = response.result as SignatureDto[];
                    console.info('Signature got successfully, signature status is: ', that.signatures[0].externalSignatureStatus);

                    // specify true signatures from approvals
                    that.specifyActions();

                    // Select a current signature
                    that.chooseSignature();

                    // Check if certificate validation is needed
                    console.debug('Current signature position is ' + that.currentSignaturePosition + '/' + that.signatures.length);
                    that.isCertificateApprovalRequired = that.signersService.isCertificateApprovalRequired(that.currentSignaturePosition,
                        that.signatures.length, that.signersService.currentSigner.signerType);


                    // Check if single or multiple documents for certificate validation text
                    if (that.isCertificateApprovalRequired) {
                        that.signatureButtonText = 'documents.button.certificate';
                        that.areMultipleDocuments = that.signatures.length > 1;
                    }

                    if (that.currentSignature) {
                        // Reset the variables (for successive calls of getSignatures)
                        that.otp = undefined;
                        that.click = undefined;
                        that.sendSms = undefined;
                        that.sendEmail = undefined;
                        that.submit = undefined;
                        that.tablet = undefined;
                        that.handsign = undefined;
                        that.otpMsg = undefined;
                        that.otpErrorMsg = undefined;
                        that.errorMsg = undefined;
                        that.consents = undefined;
                        that.otpSent = false;
                        that.controlDocumentCompleteReading = that.isControlReadingNeeded(that.currentSignature.controlDocumentCompleteReading);

                        switch (that.currentSignature.agreementMethod) {

                            // Enable the good components of the webpage
                            case AgreementMethodEnum.Smartphone:
                                console.debug('agreement method is Smartphone');
                                that.smartphone = true;
                                that.spinner.hide('spinner');
                                if (that.currentSignature.channels?.indexOf(ChannelsEnum.Sms) !== -1) {
                                    console.debug('enable SMS');
                                    that.sendSms = function () {
                                        that.sendSmartphoneAgreement(ChannelsEnum.Sms);
                                        that.linkSMSAlreadySent = true;
                                    };
                                }
                                if (that.currentSignature.channels?.indexOf(ChannelsEnum.Email) !== -1) {
                                    console.debug('enable EMAIL');
                                    that.sendEmail = function () {
                                        that.sendSmartphoneAgreement(ChannelsEnum.Email);
                                        that.linkEmailAlreadySent = true;
                                    };
                                }

                                break;
                            case AgreementMethodEnum.Otp:
                                console.debug('agreement method is OTP');
                                that.otp = true;
                                that.smartphone = false;
                                that.getConsents();
                                if (that.currentSignature.channels?.indexOf(ChannelsEnum.Sms) !== -1) {
                                    console.debug('enable SMS');
                                    that.sendSms = function () {
                                        that.sendOtp(ChannelsEnum.Sms);
                                    };
                                }

                                if (that.currentSignature.channels?.indexOf(ChannelsEnum.Email) !== -1) {
                                    console.debug('enable EMAIL');
                                    that.sendEmail = function () {
                                        that.sendOtp(ChannelsEnum.Email);
                                    };
                                }
                                that.submit = that.submitOtp;
                                break;
                            case AgreementMethodEnum.Click:
                                console.debug('agreement method is Click');
                                that.click = true;
                                that.spinner.hide('spinner');
                                that.getConsents();
                                that.submit = that.submitSimpleClick;
                                break;
                            case AgreementMethodEnum.Tablet:
                                console.debug('agreement method is Tablet');
                                that.spinner.hide('spinner');
                                that.submit = that.submitTablet;
                                that.getConsents().then(function () {
                                    //Use same algorithm as submit button to be aware if the tablet can be start automatically
                                    if (!that.isSubmitButtonDisabled() && !that.containsMandatoryConsents) {
                                        that.startTabletSignature();
                                    }
                                });
                                that.tablet = true;
                                break;
                            default:
                                that.spinner.hide('spinner');
                                console.warn('The agreement method of the current signature is not click|otp|tablet|certificate');
                                break;
                        }
                    } else {
                        console.debug("currentSignature=", that.currentSignature);
                        if (that.currentSignature === null) {
                            // There is a signature in error state
                            console.debug('There is a signature in error state');
                            that.exitError();
                        } else {// All signatures are done
                            //For scenario smartphone, go to next etape when process of signature is done( by agreements_smartphone.js), indicated by state of singer
                            if (that.smartphone) {
                                if (that.signatures[0].externalSignatureStatus === ExternalSignatureStatusEnum.Successful) {
                                    that.smartphone = false;
                                    that.retry?.unsubscribe();

                                    that.redirectionService.session(that.route, that.sessionService.id);
                                }
                            } else {
                                console.debug('All signatures are done');
                                that.redirectionService.session(that.route, that.sessionService.id);
                            }
                        }

                    }
                } else {
                    // not normal because there is at least one document to sign
                    console.warn('There is no signature');
                }
            } else {
                // If process error
                // Log the error and redirect
                console.warn(response?.error?.msg);
                that.exitError();
            }

        }, that.exitError);

    }

    submitOtp(): any {
        //test agreement form
        this.submitted = true;

        if (this.formAgreementsValidation.valid) {
            this.submitAgreement(this.validateOtp);
        } else {
            console.debug('agreementsForm is valid : ' + this.formAgreementsValidation.valid);
        }
    }

    // Send the OTP
    private validateOtp(that: AgreementsComponent) {

        console.debug('submitting otp :', that.form.otpValue);
        // Build object for request

        var obj = {
            value: that.form.otpValue
        };

        // Send the otp to the API
        return that.httpClient.submitOtp(that.sessionId, that.signersService.currentSigner.extSignerId, that.currentSignature.documentDto.extDocumentId, obj).toPromise().then(function (response) {
            if (response?.success) {
                that.otpMsg = 'document-display.sign.otp.ok';
                that.otpErrorMsg = undefined;
                that.currentSignature.externalSignatureStatus = ExternalSignatureStatusEnum.Successful;
                that.getSignatures();
            } else {
                // Display the good message for the error that occurred
                switch (response?.error?.errorCode) {
                    case Errors.invalidOtp:
                        that.otpErrorMsg = 'document-display.sign.otp.wrong';
                        break;
                    case Errors.submissionLimitOtp:
                        that.otpErrorMsg = 'document-display.sign.otp.max-continue';
                        break;
                    case Errors.totalSubmissionLimitOtp:
                        //$scope.otpErrorMsg = 'document-display.sign.otp.max-end';
                        // redirect to error page
                        that.redirectionService.error(that.route, CustomErrors.totalSubmissionLimitOtp, that.sessionId);
                        break;
                    case Errors.invalidAction:
                        that.otpErrorMsg = 'document-display.sign.otp.invalid-action';
                        break;
                    case Errors.expiredOtp:
                        that.otpErrorMsg = 'document-display.sign.otp.expiration';
                        break;
                    case Errors.noOtpInBase:
                        that.otpErrorMsg = 'document-display.sign.otp.no-otp-sent';
                        break;
                    default:
                        that.otpErrorMsg = 'document-display.sign.otp.validation.error';
                        break;
                }
                console.warn(response?.error?.msg);
            }
            that.spinner.hide('spinner-bottom');
            that.spinner.hide('spinner');
        }, that.signatureError);
    }

    startTabletSignature() {
        let that = this;
        that.displayTabletLink = true;
        // tablet service
        var activateSpinner = function (value) {
            if (value) {
                that.spinner.show('jnlpSpinner');
            } else {
                that.spinner.hide('jnlpSpinner');
            }
        };

        //Generate a PadJWS session to be able to sign with the table
        activateSpinner(true);

        this.httpClient.createJNLPSession(this.sessionId, this.signersService.currentSigner.extSignerId, this.currentSignature.documentDto.extDocumentId).toPromise().then(function (response) {
            if (response?.success) {
                let padJWSDto = response.result as PadJWSDto
                // padJWS : net.atos.saas.generic.demat.ws.rest.v10.dto.PadJWSDto
                var baseUrl = padJWSDto.frontUrl?.endsWith('/') ? padJWSDto?.frontUrl.substring(0, padJWSDto?.frontUrl.length - 1) : padJWSDto.frontUrl;
                var jnlpUrl = 'jnlp:' + baseUrl + '/ws/rest/1.0/enduser/jnlp/token/' + padJWSDto.token + '/file/tablet.jnlp' + '?token=' + sessionStorage.getItem('token');

                that.jnlpUrl = jnlpUrl;
                //Force JNLP to start
                window.location.href = jnlpUrl;

                //Pool the status of the session
                var poolingId = setInterval(function () {
                    that.httpClient.getJNLPSession(padJWSDto?.token!).toPromise().then(function (response) {
                        let padJWSDto = response?.result as PadJWSDto
                        console.debug('Current pad session status', padJWSDto?.status);

                        if (padJWSDto.status === 'COMPLETED') {
                            clearInterval(poolingId);
                            that.finishTabletAgreement();
                        } else if (padJWSDto.status === 'CANCEL') {
                            clearInterval(poolingId);
                            that.confirmCancel();
                        } else if (padJWSDto.status === 'TIMEOUT' || padJWSDto.status === 'ERROR') {
                            clearInterval(poolingId);
                            console.error('Tablet session is in state', padJWSDto.status);
                            that.redirectionService.moveTo(that.route, Routes.error.replace(Routes.params.reason, CustomErrors.unreachableService),
                                false);
                        }


                    }, function (error) {
                        console.error('There is an error getting tablet session information', error);
                        that.redirectionService.moveTo(that.route, Routes.error.replace(Routes.params.reason, CustomErrors.unreachableService),
                            false);
                    });

                }, 2000);
            } else {
                console.error('Tablet session creation is not successful');
                that.redirectionService.moveTo(that.route, Routes.error.replace(Routes.params.reason, CustomErrors.unreachableService),
                    false);
            }


        }, function (error) {
            console.error('An error occurred during tablet session creation', error);
            that.redirectionService.moveTo(that.route, Routes.error.replace(Routes.params.reason, CustomErrors.unreachableService),
                false);
        }).finally(function () {
            activateSpinner(false);
        });

    }

    //tablet
    finishTabletAgreement() {
        let that = this;
        //Reset idling + close the timeout popup in case of
        this.idle.interrupt()
        that.modalService.dismissAll()

        this.spinner.show('spinner');

        that.submitted = true;
        that.signatureOnError = false;

        //In tablet mode, the consent has alredy been sent either by the web application for epad use case (web_consent + tablet signature)
        // Or by the sbx-tablet in case of wacom for example
        that.getSignatures().then(function () {
            //reset to not display consent mandatory error
            that.submitted = false;

        }, that.signatureError);

    }

    submitSimpleClick(): any {
        this.submitAgreement(this.submitClick);
    }

    signatureError() {
        this.submitted = false;
        this.submitting = false;
        this.signatureOnErrorText = 'error.signature';
        this.signatureOnError = true;
    }

    sendConsents() {
        console.debug('sending consents');
        let obj: any[] = [];
        this.consents.forEach(function (consent) {
            consent.consentTextDtoList.forEach(function (consentText) {
                console.info('consent : ', consentText);
                obj.push(consentText.status);
            });
        });
        return this.httpClient.updateAllConsents(this.sessionId, this.signersService.currentSigner.extSignerId, this.currentSignature.documentDto.extDocumentId, obj).toPromise();
    }

    sendCertificateApproval() {
        // Check the sessionId

        let data = {
            text: this.translate.instant('certificate.approval.gcs').replace(/<.*?>/g, ''),
            link: this.certificateService.createGcsLink()
        }
        return this.httpClient.sendConsentCgs(this.sessionId, this.signersService.currentSigner.extSignerId, data);

    }

    submitAgreement(agrMeth) {
        let that = this;
        if (!this.isSubmitButtonDisabled()) {
            console.debug('submit agreement form');
            this.submitted = true;
            this.signatureOnError = false;

            this.spinner.show('spinner-bottom');

            var promise;
            let promiseCertificateApproval: Promise<any>;

            if (this.isCertificateApprovalRequired) {
                // this method is defined in the child
                promiseCertificateApproval = this.sendCertificateApproval().toPromise().then(function (response): any {
                    if (!response?.success) {
                        console.warn('An error occurred with the certificate approval');
                        console.warn(response?.error?.msg);
                        that.signatureError();
                        //Used to break the next promise chaining !
                        that.redirectionService.error(that.route, CustomErrors.unreachableService, that.sessionId);
                        return Promise.reject('failed');
                    }
                });
            } else {
                promiseCertificateApproval = Promise.resolve();
            }

            promiseCertificateApproval.then(function (): any {
                if (that.consents && that.consents.length > 0 && !that.alreadyConsented) {
                    promise = that.sendConsents().then(function (response) {
                        try {

                            if (response?.success) {
                                console.debug('consents sent : success');
                                that.currentSignature.externalSignatureStatus = ExternalSignatureStatusEnum.Consented;
                                that.alreadyConsented = true;
                                return agrMeth(that);
                            } else {
                                console.warn('An error occurred when sending the consents');
                                console.warn(response?.error?.msg);
                                that.otpErrorMsg = 'error.consents.send';
                                that.redirectionService.error(that.route, CustomErrors.invalidSession, that.sessionId);
                                return Promise.reject('failed');
                            }
                        } finally {
                            that.spinner.hide('spinner-bottom');
                        }

                    }).catch(() => {
                        that.signatureError();
                    });
                } else {
                    promise = agrMeth(that);
                }
                promise.then(function () {
                    //reset to not display consent mandatory error
                    that.submitted = false;

                }).catch(() => {
                    that.signatureError();
                });
            })
        }
    }

    submitTablet(): any {

        let that = this;
        // The check of $scope.displayTabletLink allows to do the action only once per session (F5 will revert this)
        // So signer cannot start twice the operation
        if (!this.isSubmitButtonDisabled() && !this.displayTabletLink) {
            //Trace the consent of certificate data usage
            this.spinner.show('spinner-bottom');

            let promise: Promise<any>;

            //Begin promise with the certificate data approval first.
            if (this.isCertificateApprovalRequired) {
                // this method is defined in the child
                promise = this.sendCertificateApproval().toPromise().then(function (response): any {
                    if (!response?.success) {
                        console.warn('An error occurred with the certificate approval');
                        console.warn(response?.error?.msg);
                        //Used to break the next promise chaining !
                        that.redirectionService.error(that.route, CustomErrors.unreachableService, that.sessionId);
                        return Promise.reject('failed');
                    }
                });
            } else {
                promise = Promise.resolve();
            }

            promise.then(function (): any {
                if (that.consents && that.consents.length > 0 && !that.alreadyConsented) {
                    return that.sendConsents().then(
                        function sendTabletManualSignature(response) {
                            if (response?.success) {
                                console.debug('consents sent : success');
                                that.currentSignature.externalSignatureStatus = ExternalSignatureStatusEnum.Consented;
                                that.alreadyConsented = true;
                            } else {
                                console.warn('An error occurred when sending the consents');
                                console.warn(response?.error?.msg);
                                that.otpErrorMsg = 'error.consents.send';
                                //Used to break the next promise chaining !
                                throw 'An error occurred when sending the consents';
                            }
                        });
                }
            }).then(function () {
                that.startTabletSignature();
            }, that.signatureError).finally(function () {
                that.spinner.hide('spinner-bottom');
            });

        }
    }

    getConsents(): any {
        let that = this;
        console.debug('Getting consents');
        this.containsMandatoryConsents = false;
        if (!this.currentSignature) {
            console.debug('Can\'t get consents because there is no chosen signature');
            this.consents = undefined;
            return;
        }

        this.alreadyConsented = false;
        //else test signature status
        if (this.currentSignature.externalSignatureStatus === ExternalSignatureStatusEnum.Consented) {
            this.alreadyConsented = true;
        }

        return this.httpClient.getAllConsents(that.sessionId, that.signersService.currentSigner.extSignerId, that.currentSignature.documentDto.extDocumentId).toPromise().then(function (response) {

            // Disable the spin
            that.spinner.hide('spinner');

            if (response?.success) {
                // If no error

                if ((response.result as ConsentGroupDto[]).length > 0) {
                    that.consents = [];

                    (response.result as ConsentGroupDto[]).forEach(function (consent) {

                        if (AgreementsOptions.authorizedWebConsentsTypes.indexOf(consent.type!) !== -1) {

                            consent.consentTextDtoList?.forEach(function (consentText) {
                                that.formConsentsValidation.addControl('consent-' + consent.rank + '_text-' + consentText.status?.rank, new FormControl());
                            })

                            that.consents.push(that.buildConsentLink(consent));
                        } else if (consent.type === 'WEB_MANUAL_SIGN_ZONE') {
                            that.handsign = true;
                            that.click = false;
                            that.submit = that.submitHandSignature;
                        } else {
                            console.debug('A consent group is not displayed : rank =', consent.rank);
                            console.debug('A consent group is not displayed : type =', consent.type);
                        }
                    });
                } else {
                    console.debug('There is no consent for this signature.');
                }

            } else {
                // If process error
                // Log the error and redirect
                console.warn(response?.error?.msg);
                that.exitError();
            }

        }, that.exitError);
    }

    submitHandSignature(): any {
        //test not empty submit signature
        this.submitted = true;
        if (this.signaturePad && !this.signaturePad.isEmpty()) {
            this.submitAgreement(this.submitSignature);
        }
    }

    buildConsentLink(consentGroup: any): any {
        let that = this;
        consentGroup.consentTextDtoList.forEach(function (consentText) {

            if (consentText.mandatory) {
                consentText.text = consentText.text + ' *';
                that.containsMandatoryConsents = true;
            }

            if (consentText.link) {
                //this is a consentLink
                var link = consentText.link;
                var regexp = /([^\[]*)(\[.*])([^\[]*)/g;
                var result = regexp.exec(consentText.text);
                var pre, linkText, post;
                if (result) {
                    pre = result[1];
                    linkText = result[2];
                    //remove '[' and ']'
                    linkText = linkText.substring(1, linkText.length - 1);
                    post = result[3];
                }
                //rebuild text with link
                var text = pre;
                text += '<a href="';
                text += link;
                text += '"  target="_blank" class="consentLink" >';
                text += linkText;
                text += '</a>';
                text += post;

                consentText.text = that.sanitizer.bypassSecurityTrustHtml(text);
            } else {
                consentText.text = that.sanitizer.bypassSecurityTrustHtml(consentText.text);
            }
        });

        return consentGroup;
    }

    isControlReadingNeeded(initValue: boolean) {
        var res = initValue,
            frontVal = this.rootScope.get().properties ? this.rootScope.get().properties.controlDocumentCompleteReading : false,
            consented = this.currentSignature.externalSignatureStatus === ExternalSignatureStatusEnum.Consented;

        if (typeof frontVal !== 'undefined') {
            res = frontVal;
        }
        return !consented && res;
    }

    chooseSignature() {
        let that = this;
        console.debug('Choosing signature');
        if (!this.signatures) {
            console.debug('Can\'t choose a signature because there are no signatures into the scope');
            this.currentSignature = undefined;
            return;
        }

        this.currentSignature = undefined;
        console.info('nbr of signatures: ' + this.signatures.length);
        this.signatures.forEach(function (signature, index) {
            if (!that.currentSignature) {
                console.info('Choosing signature --- signature status: ' + signature.externalSignatureStatus);
                switch (signature.externalSignatureStatus) {
                    case ExternalSignatureStatusEnum.Init:
                    case ExternalSignatureStatusEnum.Consented:
                        that.currentSignaturePosition = index + 1;
                        that.currentSignature = signature;
                        return;
                    case ExternalSignatureStatusEnum.ErrTech:
                    case ExternalSignatureStatusEnum.ErrBusiness:
                        console.debug('signature in error : ', signature.externalSignatureStatus);
                        that.currentSignature = null;
                        return;
                    case ExternalSignatureStatusEnum.Agreed:
                    case ExternalSignatureStatusEnum.Successful:
                        // Go to the next
                        break;
                    default:
                        // Log the error and redirect
                        console.warn('invalid externalSignatureStatus : ' + signature.externalSignatureStatus);
                        that.currentSignature = null;
                        return;
                }
            }
        });
    }

    specifyActions() {
        console.debug('Specify signatures actions');
        this.trueSignatures = [];
        this.approvals = [];

        for (var i = 0, j = this.signatures.length; i < j; i++) {
            var signature = this.signatures[i];
            if (signature.action === ActionEnum.Signature) {
                this.trueSignatures.push(signature);
                this.containsTrueSignatures = true;
            } else if (signature.action === ActionEnum.Approval) {
                this.approvals.push(signature);
                this.containsApprovals = true;
            }
        }
    }

    //submit hand signature
    private submitSignature(that: AgreementsComponent) {
        console.debug('submitting hand signature');
        // Build object for request


        let body: HandSignDto = {
            points: that.signaturePad.toData(),
            width: that.handSignOptions.canvasWidth,
            height: that.handSignOptions.canvasHeight,
        };

        return that.httpClient.handSignAgreement(that.sessionId, that.signersService.currentSigner.extSignerId, that.currentSignature?.documentDto?.extDocumentId, body).toPromise().then(function (response) {
            if (response?.success) {
                that.signaturePad.clear();
                that.currentSignature.externalSignatureStatus = ExternalSignatureStatusEnum.Successful;
                that.getSignatures();
            } else {
                that.signatureError();
            }
            that.spinner.hide('spinner-bottom');
        }, that.signatureError);
    }

    // Send smartphone agreement by SMS or Email
    sendSmartphoneAgreement(channel) {
        let that = this;
        console.debug('Sending smartphone agreement on channel: ', channel);

        var obj: OtpSendDto = {
            otpChannelType: channel
        };
        that.httpClient.sendToSmartphone(that.sessionId, that.signersService.currentSigner.extSignerId, that.currentSignature?.documentDto?.extDocumentId, obj).toPromise().then(function (response) {
            that.spinner.show('spinner-bottom');
            if (response?.success) {
                console.info('send smartphone sucess');
                that.smartphoneAgreementSent = true;
                var channelLabel = 'mail';
                switch (channel) {
                    case 'SMS':
                        channelLabel = 'sms';
                        break;
                    case 'EMAIL':
                        channelLabel = 'mail';
                        break;
                }
                that.smartphoneMsg = 'document-display.smartphone.send.ok-' + channelLabel;
                that.form.smartphoneValue = '';
                that.smartphoneErrorMsg = undefined;
            } else {
                // Display the good message for the error that occured
                that.scrollToAnchor('form-smartphone');

                switch (response?.error?.errorCode) {
                    case Errors.sendingLimitOtp:
                        that.otpErrorMsg = 'document-display.otp.send.max';
                        break;
                    default:
                        that.otpErrorMsg = 'document-display.otp.send.error';
                        break;
                }
                console.warn(response?.error?.msg);
            }
            that.spinner.hide('spinner-bottom');
            that.spinner.hide('spinner');

        }, that.exitError);
    }

    scrollToAnchor(anchor: string) {
        if (anchor !== null) {
            console.log(`scrolling to ${anchor}`);
            let el = document.getElementById(anchor);
            el?.scrollIntoView();
        }
    }


    // Send an OTP by SMS or Email


    sendOtp(channel) {
        let that = this;
        console.debug('Sending otp on channel : ', channel);
        this.spinner.show('spinner-bottom');

        var obj = {
            otpChannelType: channel
        };
        this.httpClient.sendOtp(this.sessionId, this.signersService.currentSigner.extSignerId, this.currentSignature.documentDto.extDocumentId, obj).toPromise().then(function (response) {
            if (response?.success) {
                that.otpSent = true;
                var channelLabel = 'mail';
                switch (channel) {
                    case 'SMS':
                        channelLabel = 'sms';
                        break;
                    case 'EMAIL':
                        channelLabel = 'mail';
                        break;
                }
                that.otpMsg = 'document-display.otp.send.ok-' + channelLabel;
                that.form.otpValue = '';
                that.otpErrorMsg = undefined;
            } else {
                // Display the good message for the error that occured
                that.scrollToAnchor("form-otp");

                switch (response?.error?.errorCode) {
                    case Errors.sendingLimitOtp:
                        that.otpErrorMsg = 'document-display.otp.send.max';
                        break;
                    default:
                        that.otpErrorMsg = 'document-display.otp.send.error';
                        break;
                }
                console.warn(response?.error?.msg);
            }
            that.spinner.hide('spinner-bottom');
            that.spinner.hide('spinner');

        }, that.exitError);
    }

    private submitClick(that: AgreementsComponent) {

        console.debug('submitting click');


        return that.httpClient.clickAgreement(that.sessionId, that.signersService.currentSigner.extSignerId, that.currentSignature.documentDto.extDocumentId).toPromise().then(function (response) {
            if (response?.success) {
                that.currentSignature.externalSignatureStatus = ExternalSignatureStatusEnum.Successful;
                that.getSignatures();
            } else {
                that.signatureError();
            }
            that.spinner.hide('spinner-bottom');
        }).catch(() => {
            that.signatureError();
        });
    }


    getDownloadUrl() {
        let data = this.currentSignature as SignatureDto;
        return this.rootScope.get().properties.api.urlraw + '/sessions/' + this.sessionId + '/documents/' + data.documentDto?.extDocumentId + '/data/raw';
    }

    getPdfInfoUrl() {
        let data = this.currentSignature as SignatureDto;
        return this.rootScope.get().properties.api.urlraw + '/sessions/' + this.sessionId + '/pdfs/' + data.documentDto?.extDocumentId + '/1'
    }

    getToken() {
        return sessionStorage.getItem("token") as string;
    }
}
